export enum ContentSharingDialogStageId {
  Destination = 1,
}

export enum ContentSharingDialogStepId {
  SelectContentForms = 1,
  SelectGalleryPages = 2,
  SelectTenantDestination = 3,
  SelectContentDestinationType = 4,
  SelectContentDestination = 5,
  SelectUser = 6,
  NotifyReviewers = 7,
}

export interface SharingDialogStep {
  id: ContentSharingDialogStepId
  label: string
  isOptional: boolean
  isCompleted: boolean
}

export interface SharingDialogStage {
  id: ContentSharingDialogStageId
  label: string
  steps: SharingDialogStep[]
  isOptional: boolean
  isCompleted: boolean
}
